<template>
	<van-tabbar fixed v-model="activeName" safe-area-inset-bottom active-color="#00754A">
		<van-tabbar-item replace name="home" to="/">
			首页
			<template #icon="props">
				<img class="img" :src="props.active ? homeActiveIcon : homeIcon" />
			</template>
		</van-tabbar-item>
		<van-tabbar-item replace name="sort" to="/sort">
			分类

			<template #icon="props">
				<img class="img" :src="props.active ? classActiveIcon : classIcon" />
			</template>
		</van-tabbar-item>
		<van-tabbar-item replace name="user" to="/user">
			我的

			<template #icon="props">
				<img class="img" :src="props.active ? mineActiveIcon : mineIcon" />
			</template>
		</van-tabbar-item>
	</van-tabbar>
</template>

<script>
export default {
	name: 'TabBar',
	data() {
		return {
			activeName: this.active,
			homeIcon: require('@/assets/images/tabbar/home.png'),
			homeActiveIcon: require('@/assets/images/tabbar/home_active.png'),
			classIcon: require('@/assets/images/tabbar/class.png'),
			classActiveIcon: require('@/assets/images/tabbar/class_active.png'),
			mineIcon: require('@/assets/images/tabbar/mine.png'),
			mineActiveIcon: require('@/assets/images/tabbar/mine_active.png'),
		}
	},
	props: ['active'],
	watch: {
		active(newVal) {
			this.activeName = newVal
		},
	},
	created() {
		// this.value = this.active
	},
	methods: {
		// changeTab() {
		//   if (this.value === 0) {
		//     this.$router.push('/')
		//   }
		//   if (this.value === 1) {
		//     this.$router.push('/sort')
		//   }
		//   if (this.value === 2) {
		//     this.$router.push('/user')
		//   }
		// },
	},
}
</script>

<style scoped>
.img {
	width: 24px;
	height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/tabBar/index.vue